import * as React from "react";
import type { SVGProps } from "react";
const SvgImageSlashed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.94 19.52s-.05-.1-.1-.14a.3.3 0 0 0-.076-.05q-.029-.011-.054-.03L4.74 3.33q-.023-.036-.042-.072a.6.6 0 0 0-.068-.108 1 1 0 0 0-.2-.14l-.72-.72c-.39-.39-1.03-.39-1.42 0s-.39 1.03 0 1.42l.27.27c-.36.61-.57 1.29-.57 2.02v12c0 2.21 1.79 4 4 4h12c.71 0 1.41-.21 2.01-.57l.27.27c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-.77-.77zM18 20H6c-1.1 0-2-.9-2-2v-.59l4.36-4.36a.996.996 0 1 0-1.41-1.41L4 14.59V6c0-.18.03-.35.07-.51l14.44 14.44c-.17.04-.34.08-.51.08zm0-18H7c-.55 0-1 .45-1 1s.45 1 1 1h11c1.1 0 2 .9 2 2v8.59l-1.31-1.31c-.37-.35-.77-.61-1.2-.77a1 1 0 0 0-1.28.59c-.19.51.08 1.09.59 1.28.17.06.34.17.49.32l3 3c.09.09.2.17.33.22.12.05.25.08.38.08s.26-.03.38-.08A1.02 1.02 0 0 0 22 17V6c0-2.21-1.79-4-4-4m-2 3c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3m0 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgImageSlashed;
